import { GuideCategory } from './types';
import { gettingStartedGuide } from './getting-started';
import { plansBillingGuide } from './plans-billing';
import { socialSharingGuide } from './social-sharing';
import { studioInterfaceGuide } from './studio-interface';
import { simulationModesGuide } from './simulation-modes';
import { visualCustomizationGuide } from './visual-customization';
import { audioIntegrationGuide } from './audio-integration';
import { troubleshootingGuide } from './troubleshooting';

export * from './types';

export const GUIDE_CATEGORIES: GuideCategory[] = [
  gettingStartedGuide,
  plansBillingGuide,
  socialSharingGuide,
  studioInterfaceGuide,
  simulationModesGuide,
  visualCustomizationGuide,
  audioIntegrationGuide,
  troubleshootingGuide
];
